import { gql } from '@apollo/client'

export const ChecklistFragments = {
  checklistTemplateInfo: gql`
    fragment checklistTemplateInfo on ChecklistTemplateNode {
      id
      title
      userTypes {
        id
        name
      }
      mode
      items {
        id
        text
        done
      }
    }
  `,
  shallowChecklistTemplateInfo: gql`
    fragment shallowChecklistTemplateInfo on ChecklistTemplateNode {
      id
      title
      userTypes {
        id
        name
      }
    }
  `,
}
